<template>
<div>
  <div id="testnum"><div id="cs" style="width: 210px; color: #fff">.</div></div>
  <div
    class="down_nav_list"
    :style="{ width: innerwidth, transition: trans_time }"
  >
    <div v-show="rightBtn" class="gallery__box">
      <ul id="scro" class="gallery__list">
        <li
          :id="item.time"
          v-for="(item, index) in pictureArr"
          :class="{ select: displaylist == index }"
          :key="index"
        >
          <img @click="btn(index)" :src="item.img" style="width: 210px" />
          <p class="time_stap" style="color: #666">{{ item.time }}</p>
        </li>
      </ul>
    </div>
    <div @click="maskBtn($event)" v-show="showMask" class="gallery__big">
      <div class="gallery__big_box">
        <div ref="mask" class="gallery__big_wrap">
          <i
            @click="leftBtn(maskImg?.img)"
            class="el-icon-arrow-left"
            style="
              display: inline-block;
              height: 100%;
              font-size: 54px;
              cursor: pointer;
              color: #fff;
            "
          ></i>
          <img :src="maskImg.img" />
          <i
            @click="rightBtn1(maskImg?.img)"
            class="el-icon-arrow-right"
            style="
              display: inline-block;
              height: 100%;
              font-size: 54px;
              cursor: pointer;
              color: #fff;
            "
          ></i>
        </div>
      </div>
    </div>
    <button
      v-show="rightBtn"
      :disabled="closePictureBtn"
      @click="pictureSwitch"
      class="gallery_btn"
    >
      <i class="el-icon-d-arrow-left"></i>
    </button>

    <!-- <button @click="openBtn()" class="gallery_btn1">
      <i class="el-icon-d-arrow-right"></i>
    </button> -->
  </div>
</div>
</template>

<script>
export default {
  props: {
    perf_second_data: Object,
  },

  data() {
    return {
      innerwidth: '',
      trans_time: '',
      rightBtn: true,
      pictureArr: [],
      closePictureBtn: false,
      showDrawer: false,
      treeNum: 0,
      maskImg: {
        img: "",
      },
      showMask: false,
      displaylist: '',
      flag: true,
      file: 0,
    }
  },

  computed: {
    imgData() {
      return this.perf_second_data?.['截图']?.rows || {}
    }
  },

  methods: {
    init() {
      this.pictureArr = []
      const pictureList = this.imgData?.screen_shot || []
      const timeList = this.imgData?.timeline

      if (!pictureList?.length || !timeList?.length) {
        this.rightBtn = false
      } else {
        this.rightBtn = true
      }

      this.pictureArr = pictureList.map((img, index) => {
        return {
          img,
          time: timeList[index],
        }
      })
    },

    showScreenShot(month) {
      if (!this.pictureArr?.length) return
      let boxWidth = document.getElementById(this.pictureArr[0]?.time)?.offsetWidth

      // 获取居中平移距离
      let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

      // 将每一次平移居中位置放置每一个对象中
      this.pictureArr.forEach(function (v) {
        v.ofwidth = ofwidth -= boxWidth + 10;
        //
        //
      });
      let x = month;
      let pictureObj = this.pictureArr.filter(function (v) {
        return v.time === x;
      });

      let file1 = this.file
      if (pictureObj.length > 0) {
        file1 = pictureObj[0].ofwidth + "px";
        document.getElementById(
          "scro"
        ).style.transform = `translateX(${file1})`;
        document.getElementById(pictureObj[0].time).firstChild.style.outline =
          "6px solid #4271fb";
        let po = this.sibling1(document.getElementById(pictureObj[0].time));
        //     var siblings = sibling(document.getElementById(pictureObj[0].time));
        po.forEach(function (v) {
          //
          v.firstChild.style.outline = 0;
        });
      } else {
        let pic = this.pictureArr.filter(
          (v) => v.time === this.subtractTwoSeconds(x)
        )[0];
        file1 = pic.ofwidth + "px";
        document.getElementById(
          "scro"
        ).style.transform = `translateX(${file1})`;
        document.getElementById(pic.time).firstChild.style.outline =
          "6px solid #4271fb";
        let po = this.sibling1(document.getElementById(pic.time));
        //     var siblings = sibling(document.getElementById(pictureObj[0].time));
        po.forEach(function (v) {
          //
          v.firstChild.style.outline = 0;
        });
      }
    },

    subtractTwoSeconds(timeString) {
      // 将分秒数据转换为秒数
      const [minutes, seconds] = timeString.split(":");
      const totalSeconds = parseInt(minutes) * 60 + parseInt(seconds);
      // 减去 1 秒
      const newTotalSeconds = totalSeconds - 1;
      // 转换为分秒格式
      const resultMinutes = Math.floor(newTotalSeconds / 60);
      const resultSeconds = newTotalSeconds % 60;
      const result = `${resultMinutes < 10 ? "0" : ""}${resultMinutes}:${
        resultSeconds < 10 ? "0" : ""
      }${resultSeconds}`;
      return result;
    },

    sibling1(elm) {
      var a = [];
      var p = elm.parentNode.children;
      for (var i = 0, pl = p.length; i < pl; i++) {
        if (p[i] !== elm) a.push(p[i]);
      }
      return a;
    },

    //图片开关
    pictureSwitch() {
      if (this.flag) {
        this.innerwidth = 100 + "%";
        this.trans_time = "0.5s";
        this.flag = false;
      } else {
        this.innerwidth = 40 + "px";
        this.flag = true;
      }
    },
    maskBtn(ev) {
      if (!this.$refs.mask.contains(ev.target)) {
        this.showMask = false;
        this.closePictureBtn = false;
      }
    },

    btn(a) {
      this.displaylist = a;
      this.maskImg.img = this.pictureArr[a].img;
      this.showMask = true;
      this.closePictureBtn = true;
    },

    sibling(elm) {
      var a = [];
      var p = elm.parentNode.children;
      for (var i = 0, pl = p.length; i < pl; i++) {
        if (p[i] !== elm) a.push(p[i]);
      }
      return a;
    },

    leftBtn(item) {
      if (this.pictureArr.length != 0) {
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        this.pictureArr.forEach(function (v) {
          //
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let i = 0;

        this.pictureArr.forEach((v, index) => {
          if (v.img === item) {
            i = index;
          }
        });

        if (i - 1 >= 0) {
          let file1 = "";
          file1 = this.pictureArr[i - 1].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;

          document.getElementById(
            this.pictureArr[i - 1].time
          ).firstChild.style.outline = "6px solid #4271fb";
          var siblings = this.sibling(
            document.getElementById(this.pictureArr[i - 1].time)
          );

          siblings.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
          this.maskImg.img = this.pictureArr[i - 1].img;
        }
      }
    },

    rightBtn1(item) {
      if (this.pictureArr.length != 0) {
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        this.pictureArr.forEach(function (v) {
          //
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let i = 0;

        this.pictureArr.forEach((v, index) => {
          if (v.img === item) {
            i = index;
          }
        });

        if (i + 1 <= this.pictureArr?.length) {
          let file1 = "";
          file1 = this.pictureArr[i + 1].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(
            this.pictureArr[i + 1].time
          ).firstChild.style.outline = "6px solid #4271fb";
          var siblings = this.sibling(
            document.getElementById(this.pictureArr[i + 1].time)
          );
          siblings.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
          this.maskImg.img = this.pictureArr[i + 1].img;
        }
      }
    },

    // openBtn() {
    //   this.treeNum++;
    //   this.showDrawer = true;
    // },
  }
}
</script>

<style scoped>
.down_nav_list {
  width: 100%;

  position: fixed;
  display: flex;
  justify-content: flex-end;
  z-index: 31;
  bottom: 0;
  right: 0;
  width: 40px;
  height: 18.5%;
}
.down_nav_list li {
  list-style: none;
}

.gallery__box {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-right: 40px;
  background: rgba(9, 11, 24, 0.9);
}
.gallery__list {
  display: flex;
  height: 100%;
  align-items: center;
  margin: 0;
  padding-left: 0;
  justify-content: center;

  transition: 2s;
}
.gallery__list li {
  display: flex;
  text-align: center;
  position: relative;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.gallery__list li:nth-child(n + 2) {
  margin-left: 10px;
}
.gallery__list img {
  height: 102.112px;
}
.gallery_btn {
  width: 40px;
  background: #ff0;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  box-shadow: 0 2px 10px rgba(66, 113, 251, 0.4);
  color: rgba(171, 174, 176);
  background: #fff;
  cursor: pointer;
  border: 0;
  outline: 0;
}
.gallery_btn[disabled] {
  cursor: not-allowed;
}

.gallery_btn1 {
  width: 40px;
  background: #ff0;
  z-index: 99;
  position: fixed;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  height: 75px;
  box-shadow: 0 2px 10px rgba(66, 113, 251, 0.4);
  color: rgba(171, 174, 176);
  background: #fff;
  cursor: not-allowed;
  border: 0;
  outline: 0;
}
.gallery_btn i {
  font-size: 26px;
  font-weight: bold;
  color: rgba(151, 157, 176);
}
.gallery_btn1 i {
  font-size: 26px;
  font-weight: bold;
  color: rgba(151, 157, 176);
}
.gallery_btn:hover {
  background: #e3e6ef;
}

.time_stap {
  position: absolute;
  width: 100%;
  text-align: center;
  top: 85%;
  font-size: 0.14rem;
  color: #666;
  line-height: 10px;
  margin-top: 0.1rem;
}

.gallery__list li:before {
  pointer-events: none;
  content: "";
  position: absolute;
  top: 20%;
  bottom: 20%;
  left: 0;
  right: 0;
  background: rgba(9, 11, 24, 0.5);
}
.gallery__list li {
  padding: 2px;
}

.gallery__list li img {
  cursor: pointer;
}

.gallery__list .select {
  background: none;
}
.gallery__list li img {
  border: 1px solid transparent;
}
.gallery__list .select img {
  border: 1px solid #313651;
}

.select::before {
  pointer-events: none;
  content: "";
  position: absolute;
  top: 20%;
  bottom: 20%;
  left: 0;
  right: 0;
  background: none !important;
}
.gallery__big {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(9, 11, 24, 0.9);
}
.gallery__big_box {
  position: absolute;
  top: 11.1%;
  bottom: 23.1%;
  left: 8.3%;
  right: 8.3%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gallery__big_wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

#testnum {
  position: relative;
}
#cs {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -110px;
  margin-top: -110px;
}
</style>